(function () {
  if (!('IntersectionObserver' in window)) return;

  var root = document.querySelector('.lp-dropshipping-wrapper');
  if (root) root.classList.add('js');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08 }
  );

  document.querySelectorAll('.lp-dropshipping .panel').forEach(function (panel) {
    observer.observe(panel);
  });
})();
